import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
import { appConfig } from './utils/config'

document.title = appConfig.appTitle
createApp(App).use(router).mount('#app')
